import { getDisplayPreviewUrl } from "../../utils/filePreview";
import { isVectorDocUrl } from "./proofRowUtils";

export const resolveGeneratedVectorPreview = ({
  filePath,
  previewImageUrl,
  previewUrl,
  previewStatus,
  previewKind,
} = {}) => {
  if (!isVectorDocUrl(filePath)) return "";

  const generatedPreview = getDisplayPreviewUrl({
    filePath,
    previewImageUrl: previewImageUrl || previewUrl,
    previewStatus,
    previewKind,
  });

  return generatedPreview && generatedPreview !== filePath ? generatedPreview : "";
};
